import {
  ADD_ITEM,
  CHANGE_ITEM,
  UPDATE_ITEM,
  FETCH_ITEM_LIST,
  SET_QUARTER,
  SET_TYPE,
  SET_YEAR, FETCH_ITEM_LIST_SUCCESS, FETCH_ITEM_LIST_ERROR, RESET_ITEM_LIST, SET_MONTH
} from 'items/actions/types'

const currentYear = (new Date()).getFullYear()
const currentQuarter = 0

const initialState = {
  currentYear: currentYear,
  currentQuarter: currentQuarter,
  currentMonth: 0,
  currentType: -1,
  itemList: [],
  itemListErrors: [],
  itemListLoading: false,
  itemListHasErrors: false,
  itemListIsLoaded: false,
  newItem: null,
  updatedItem: null
}

export default function items (state = initialState, action) {
  switch (action.type) {
    case SET_YEAR:
      return {
        ...state,
        itemListIsLoaded: false,
        currentYear: action.currentYear
      }
    case SET_MONTH:
      return {
        ...state,
        itemListIsLoaded: false,
        currentMonth: action.currentMonth
      }
    case SET_QUARTER:
      return {
        ...state,
        itemListIsLoaded: false,
        currentQuarter: action.currentQuarter
      }
    case SET_TYPE:
      return {
        ...state,
        itemListIsLoaded: false,
        currentType: action.currentType
      }
    case FETCH_ITEM_LIST:
      return {
        ...state,
        itemListLoading: true
      }
    case FETCH_ITEM_LIST_SUCCESS:
      return {
        ...state,
        itemListLoading: false,
        itemListIsLoaded: true,
        itemList: action.itemList
      }
    case FETCH_ITEM_LIST_ERROR:
      return {
        ...state,
        itemListLoading: false,
        itemListHasErrors: true,
        itemListIsLoaded: true,
        itemListErrors: action.errors
      }
    case RESET_ITEM_LIST:
      return {
        ...state,
        itemListLoading: false,
        itemListHasErrors: false,
        itemListIsLoaded: false,
        itemListErrors: [],
        itemList: []
      }
    case ADD_ITEM:
      return {
        ...state,
        newItem: action.payload
      }
    case UPDATE_ITEM:
      return {
        ...state,
        updatedItem: action.payload
      }
    case CHANGE_ITEM:
      return {
        ...state,
        items: action.items
      }
    default:
      return state
  }
}
